import React from 'react';
import { Link } from 'react-router-dom';
import '../validate/EmailValidation.css';  // Include your CSS file

const EmailValidatedSuccess = () => {
  return (
    <div className="validation-container success">
      <div className="validation-box">
        <h2 className="validation-title">Email Successfully Validated!</h2>
        <p className="validation-message">
          Congratulations! Your email has been successfully validated. You can now start using your account.
        </p>
        <Link to="/login" className="btn-email btn-success">Go to Login</Link>
      </div>
    </div>
  );
};

export default EmailValidatedSuccess;
